// File: noviopus-ats-client/src/Pages/Job/Create/OrgSelectorDialog/index.tsx
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dialog, DialogTitle, DialogContent, List, ListItem, ListItemAvatar, Avatar, ListItemText, Typography, Box } from '@material-ui/core';
import BusinessIcon from '@material-ui/icons/Business';
import { useTranslation } from 'react-i18next';

import { setJobCreationContext, closeOrgSelector } from '@/features/Job/jobCreateSlice'; // Import setJobCreationContext
import { selectShowOrgSelector } from '@/features/Job/selectors';
import { fetchOrganization } from '@/features/Organization/organizationSlice'; 
// FIX: Import new Context action
import { setActiveOrganization } from '@/features/Navigation/contextSlice';  

import { selectCurrentAccount } from '@/features/Auth/selectors';
import { push } from '@/App/router/actions';

import styles from './OrgSelectorDialog.module.scss';

const OrgSelectorDialog: React.FC = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation('job');
  
  const isOpen = useSelector(selectShowOrgSelector) as boolean;
  const account = useSelector(selectCurrentAccount);
  
  const companies = account?.companies || [];

  const handleSelect = (company: any) => {
      const id = company.id || company._id;

      // 1. Update Global App Context (Header, Sidebar)
      // FIX: Use setActiveOrganization with ID
      dispatch(setActiveOrganization(id));
      dispatch(fetchOrganization(id));

      // 2. CRITICAL: Lock the ID into the Job Draft State & Local Storage
      dispatch(setJobCreationContext(id));
      localStorage.setItem('job_wizard_context_org', id);
      
      // 3. Close & Navigate
      dispatch(closeOrgSelector());
      dispatch(push('/jobs/new/basics'));
  };

  const handleClose = () => {
      dispatch(closeOrgSelector());
  };

  return (
    <Dialog open={!!isOpen} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h6" align="center" style={{ fontWeight: 600, color: '#485C6E' }}>
             {t('new-job.select-company', 'Select an organization to create the new job opening.')}
        </Typography>
      </DialogTitle>
      
      <DialogContent className={styles.list}>
        {companies.length === 0 ? (
           <Box p={3}>
                <Typography align="center" className={styles.description}>
                    {t('no_organizations', 'No organizations found.')}
                </Typography>
           </Box>
        ) : (
           <List>
               {companies.map((company: any) => (
                   <ListItem 
                      key={company.id || company._id} 
                      button 
                      onClick={() => handleSelect(company)}
                      className={styles.item}
                   >
                       <ListItemAvatar>
                           <Avatar style={{ backgroundColor: '#fff', border: '1px solid #e0e0e0', color: '#00799B' }}>
                               {company.logo ? (
                                   <img src={company.logo} alt={company.name} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                               ) : (
                                   <BusinessIcon />
                               )}
                           </Avatar>
                       </ListItemAvatar>
                       <ListItemText 
                           primary={company.name}
                           primaryTypographyProps={{ style: { fontWeight: 500, color: '#485C6E' } }} 
                       />
                   </ListItem>
               ))}
           </List>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default OrgSelectorDialog;